import { Player } from "@lottiefiles/react-lottie-player";
import styles from "./Preloader.module.css";

interface PreloaderProps {
  width?: string | number;
  height?: string | number;
}

const Preloader: React.FC<PreloaderProps> = ({ width = 360, height = 360 }) => {
  return (
    <div className={styles.container}>
      <Player autoplay loop src="/animations/loading.json" style={{ width, height }} />
      <p className={styles.text}>ФОРМИРУЕМ ПРОГНОЗ</p>
    </div>
  );
};

export default Preloader;
